export default __webpack_public_path__ + "static/media/logo.039433d0.png";